export default __webpack_public_path__ + "static/media/service-training.d90940bb.svg";